<template>
    <div id="dashboard" class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <div class="header text-center">
                <h3 class="title">{{ $t('Welcome to the Navitas Dashboard!')}}</h3>
                <p class="category">{{$t('Please click on the tiles below to open your Navitas platform(s).')}}</p>
            </div>
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <div v-if="showAlert" class="alert alert-primary">
                <button type="button" aria-hidden="true" class="close" @click="hideAlert">×</button>
                <span>{{$t('We\'re launching our new academy! Please ignore the \'New Academy\' button unless you have signed up. To learn more, please speak with your account manager.')}}</span>
            </div>
        </div>
        <dashboard-platform v-for="(platform, key) in platforms" :data="platform" :key="key"/>
    </div>
</template>

<script>
import DashboardPlatform from "./DashboardPlatform";
import {mapMutations, mapGetters} from "vuex";

export default {
        name: "Dashboard",
        components: {DashboardPlatform},
        computed: {
            ...mapGetters('app', {
                authenticatedInitData: 'getAuthenticatedInitData',
            }),
            platforms() {
                let list = [
                    {
                        slug: this.$enums.PlatformSlugEnum.COMPLIANCE,
                        name: 'COMPLIANCE',
                    },
                    {
                        slug: this.$enums.PlatformSlugEnum.DFS,
                        name: 'DIGITAL FOOD SAFETY',
                    },
                    {
                        slug: this.$enums.PlatformSlugEnum.ACADEMY,
                        name: 'ACADEMY',
                    },
                    {
                        slug: this.$enums.PlatformSlugEnum.NEW_ACADEMY,
                        name: 'NEW ACADEMY',
                    },
                ];

                const user = this.authenticatedInitData.user ?? {};
                const accesses = user.accesses ?? [];
                const academyAccess = accesses.find(app => app.appSlug === this.$enums.PlatformSlugEnum.ACADEMY) ?? {};
                const migrationStatus = academyAccess.migrationStatus;

                // Remove the normal academy button if the user doesn't have access, but keep the new academy button
                if(!academyAccess.hasAccess) {
                    list = list.filter(p => p.slug !== this.$enums.PlatformSlugEnum.ACADEMY);
                }else if (migrationStatus === 'navitas' || migrationStatus === 'calibrae') {
                    list = list.filter(p => p.slug !== this.$enums.PlatformSlugEnum.NEW_ACADEMY);
                }

                return list;
            },
            showAlert() {
                return this.showOnlyEmailAlert === '1';
            }
        },
        data() {
            return {
                data: {},
                showOnlyEmailAlert: this.$cookies.get('onlyEmailAlert') ?? '1'
            }
        },
        methods: {
            hideAlert() {
                this.showOnlyEmailAlert = '0';
                this.$cookies.set('onlyEmailAlert', 0);
            },
            ...mapMutations('app', {
                setLoadingState: 'setLoadingState',
                setTitlePage: 'setTitlePage',
            })
        },
        mounted() {
            this.setTitlePage(this.$t('Dashboard'));
        }
    }
</script>

<style lang="scss">
    #dashboard {
        p {
            color: #3c4858 !important;
        }
    }
</style>